var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"props-display-container"},[_vm._m(0),_c('div',{staticClass:"props-content"},[_c('pre',{staticClass:"props-json"},[_vm._v(_vm._s(_vm.propsContent))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"props-header"},[_c('h3',[_vm._v("Modal Props and Values")])])
}]

export { render, staticRenderFns }